import type { FC } from "react";

import { IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { FIND_LEADS_SEARCH_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import {
    StyledHeaderListContainer,
    StyledSearchTextBox,
} from "app/pages/sales-intelligence/modules/lists/containers/ListTabsContainer/styles";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

type SavedSearchesHeaderContainerProps = {
    searchText: string;
    setSearchText: (searchText: string) => void;
};

const SavedSearchesHeaderContainer: FC<SavedSearchesHeaderContainerProps> = ({ setSearchText, searchText }) => {
    const onSearch = async (text: string) => {
        await setSearchText(text);
    };

    const onSearchClear = async () => {
        await setSearchText("");
    };

    const handleFindNewLeadsClick = () => {
        proNavigator.go(FIND_LEADS_SEARCH_ROUTE);
    };

    return (
        <StyledHeaderListContainer>
            <StyledSearchTextBox
                onChange={onSearch}
                onClear={onSearchClear}
                searchText={searchText}
                placeholder={translate("si.components.list.search_placeholder")}
            />
            <FlexRow alignItems="center">
                <IconButton
                    type="primary"
                    iconName="search"
                    iconSize="xs"
                    onClick={handleFindNewLeadsClick}
                >
                    {translate("si.my-lists.saved-searches.button.find-new-leads")}
                </IconButton>
            </FlexRow>
        </StyledHeaderListContainer>
    );
};

export default SavedSearchesHeaderContainer;
